import { UserType } from "seneca-common/features/users/state";

type UserTypeFromServer = {
  userId: string;
  givenName: string;
  familyName: string;
  email: string;
};

export function convertToUser({ userId, ...rest }: UserTypeFromServer) {
  const { givenName, familyName } = rest;
  const user: UserType = {
    id: userId,
    name: givenName && familyName && `${givenName} ${familyName}`,
    ...rest
  };
  return user;
}
